import { OndigoNS } from '../../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.OpenimmoSearch = function (element) {

        this.$form = $(element);
        this.initSearch();
    };

    OndigoNS.OpenimmoSearch.prototype = {
        initSearch: function () {

            var scope = this;
            this.$form.on('submit', function (e) {

               var $newUrl= scope.addOption();

               window.location.href=$newUrl;
                return false;

            });
        },

        addOption: function() {

            var $objektIdField=$('#objektId'),
                url= this.$form.attr("action"),
                newUrl=url.split("/")[1] + "/#",
                urlElements=[],
                availableIds=OndigoNS.availableImmoIds ,
                objektId= "";

            if($objektIdField.length){
                objektId = $objektIdField.val();

                 if(objektId!="" && $.inArray(objektId, availableIds) != -1){
                    url="/immobilie-kaufen/immobilie/"+objektId;
                    return url;
                } else if(!objektId=="" && $.inArray(objektId, availableIds)== -1){
                     url+="#IdnotFound";
                     return url;
                 }

            }

            this.$form.find('select').each(function(){
                var $optionText =$(this).find('option:selected').text(),
                    $optionValue=$(this).val(),
                    $optionId=$(this).attr("id");

                if($(this).attr("id")=="region" && $optionValue ){
                    urlElements.push ($optionId+ "=" + $optionText);
                }

                if($(this).attr("id")=="type" && $optionValue){
                    urlElements.push ($optionId+ "=" +$optionText);
                }

            });

            if( urlElements.length>0){
                urlElements=urlElements.join("&");
                newUrl+=urlElements;
                url=newUrl;
                return url;
            }else{
                return url;
            }
        }
    };
    // plugin definition

    $.fn.openimmoSearch = function () {
        return new OndigoNS.OpenimmoSearch(this);
    };
    $.fn.openimmoSearch.Constructor = OndigoNS.OpenimmoSearch;

}(window.jQuery));

$(document).ready(function () {
    'use strict';

    var $openimmoform = $('#openimmo-quick-search-form');

    if ($openimmoform.length) {
        $openimmoform.openimmoSearch();
    }
});